<div class="card card-custom section-margin-bottom-60">
    <ng-container *ngIf="viewModel$|async as viewModel">
    <div class="card-header criterion-header">
        <div class="card-title">
            <div class="card-label">
                <span >Criterions</span>
            </div>
            <mat-icon 
                style="cursor: pointer; display: flex; align-items: center;" 
                container="body" 
                [ngbPopover]="'TOOLTIP.VALUATION_PROCESS.CRITERIONS.DESCRIPTION'|translate"
                [popoverTitle]="'TOOLTIP.VALUATION_PROCESS.CRITERIONS.TITLE'|translate">
                help
            </mat-icon>
        </div>
        <div class="card-toolbar">
            <div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
                <a ngbDropdownToggle href="javascript:;"
                    class="btn btn btn-label-brand btn-bold btn-sm"
                    style="cursor: pointer !important;">
                    Add
                </a>
                <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg-right" style="width: 150px;">
                    <ul class="navi navi-hover">
                        <li class="navi-item">
                            <a href="javascript:;" class="navi-link" (click)="onAddExistingCriterion(viewModel.refNums)">
                                <span class="navi-text">Existing criterion</span>
                            </a>
                        </li>
                        <li class="navi-item">
                            <a href="javascript:;" class="navi-link" (click)="onAddCustomCriterion(viewModel.refNums)">
                                <span class="navi-text">Custom criterion</span>
                            </a>
                        </li>
                        <li class="navi-item">
                            <a href="javascript:;" class="navi-link" (click)="onAddFromTemplate(viewModel.propertySubTypeId, viewModel.refNums)">
                                <span class="navi-text">From template</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body criterion-body">
        <div class="col-md-12 mat-table-wrapper">
            <table mat-table class="lmat-elevation-z8" [dataSource]="viewModel.dataSource">
        
                <!-- Headers -->
                <ng-container [matColumnDef]="'input-' + viewModel.refNums.length + '-header'">
                    <th mat-header-cell 
                        *matHeaderCellDef 
                        [attr.colspan]="2">Qualitative Inputs</th>
                </ng-container>
        
                <ng-container *ngFor="let refNum of viewModel.refNums; let i = index" [matColumnDef]="'com-' + i + '-' + viewModel.refNums.length + '-header'">
                    <th mat-header-cell *matHeaderCellDef>
                        <span class="cell">
                            {{refNum}}
                            <span>
                                <button mat-icon-button color="primary" (click)="onShowComparable(refNum)">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="onRemoveComparable(refNum)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </span>
                        </span>
                    </th>
                </ng-container>
        
                <ng-container [matColumnDef]="'tp-' + viewModel.refNums.length +'-header'">
                    <th mat-header-cell *matHeaderCellDef>
                        Target Property
                        <button mat-icon-button color="primary" (click)="onShowComparableOverview(viewModel.refNums)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </th>
                </ng-container>
        
                <ng-container matColumnDef="action-header">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                </ng-container>
        
                <!-- Cells -->
                <ng-container [matColumnDef]="'criterion-' + viewModel.refNums.length">
                    <td mat-cell *matCellDef="let criterion" [ngClass]="{'bg-orange': !criterion.name}">
                        <!-- {{criterion.name ? criterion.name : 'Not defined'}} -->
                        {{ criterion.publicName }}
                    </td>
                </ng-container>
        
                <ng-container [matColumnDef]="'category-' + viewModel.refNums.length">
                    <td mat-cell *matCellDef="let criterion">{{criterion.categoryName}}</td>
                </ng-container>
        
                <ng-container *ngFor="let refNum of viewModel.refNums; let i = index" [matColumnDef]="'com-' + i + '-' + viewModel.refNums.length">
                    <!-- <td mat-cell *matCellDef="let criterion" 
                        [ngClass]="{
                            'bg-orange': criterion.name === null && (criterion.comValues[com.id] === null || criterion.comValues[com.id] === undefined),
                            'bg-red': criterion.name && (criterion.comValues[com.id] == 'Unknown' || criterion.comValues[com.id] === '' || criterion.comValues[com.id] === null),
                            'bg-green': (criterion.comValues[com.id] 
                                || criterion.comValues[com.id] === 0) && criterion.comValues[com.id] != 'Unknown'
                        }">
                        <span *ngIf="criterion.id !== 1; else considerationCom">
                            {{criterion.name === null 
                                ? 'Not defined'
                                : criterion.comValues[com.id] }}
                        </span>
                        <ng-template #considerationCom>
                            <span class="consideration-criterion">
                                <span>
                                    {{(criterion.comValues[com.id] !== null && criterion.comValues[com.id] !== undefined) 
                                        ? (criterion.comValues[com.id].toFixed(2) | mask:'separator.2':{thousandSeparator: ','} )
                                        : 'Not defined'}} 
                                </span>
                                <button *ngIf="criterion.comConsideration[com.id].process !== considerationProcess.NoProcess" 
                                    mat-icon-button 
                                    color="primary" 
                                    [disabled]="readonly"
                                    (click)="editConsideration(criterion, com)">
                                    <mat-icon>create</mat-icon>
                                </button>
                            </span>
                        </ng-template>
                    </td> -->
                    <td mat-cell *matCellDef="let criterion"
                        [ngClass]="{
                            'bg-red': criterion.type == 'Default' && (criterion.values[refNum].kind == 'unknown' || criterion.values[refNum].kind == 'not applicable'),
                            'bg-green': criterion.type == 'Consideration' || (criterion.type == 'Default' && criterion.values[refNum].kind == 'simple') 
                        }">
                        <span *ngIf="criterion.type == 'Default' || criterion.type == 'Custom'; else considerationCom">
                            {{ criterion.values[refNum].kind == 'simple' 
                                ? criterion.values[refNum].value 
                                : criterion.values[refNum].kind == 'unknown'
                                    ? 'Unknown'
                                    : 'Not Applicable' }}
                        </span>
                        <ng-template #considerationCom>
                            <span class="consideration-criterion">
                                <span class="consideration-value">
                                    <span>
                                        {{ criterion.values[refNum].value != null 
                                            ? (criterion.values[refNum].value.toFixed(2) | mask:'separator.2':{thousandSeparator: ','})
                                            : 'Not defined' }}
                                    </span>
                                    <span class="gst-status" *ngIf="gstStatusName(criterion.values[refNum]) as gstStatus">
                                        ({{ gstStatus }})
                                    </span>
                                </span>
                                <button *ngIf="criterion.values[refNum].kind != 'no process'" 
                                    mat-icon-button 
                                    color="primary" 
                                    (click)="editConsiderationValue(refNum, criterion, criterion.values[refNum], viewModel.rates[refNum])">
                                    <mat-icon>create</mat-icon>
                                </button>
                            </span>
                        </ng-template>
                    </td>
                </ng-container>
        
                <ng-container [matColumnDef]="'tp-' + viewModel.refNums.length">
                    <!-- <td mat-cell *matCellDef="let criterion"
                        [ngClass]="{
                            'bg-orange': criterion.name === null && criterion.tpValue === null,
                            'bg-red': criterion.name && (criterion.tpValue == 'Unknown' || criterion.tpValue === '' || criterion.tpValue === null),
                            'bg-green': (criterion.tpValue || criterion.tpValue === 0) && criterion.tpValue != 'Unknown',
                            'bg-gray': criterion.tpValue === undefined
                        }">
                        <span *ngIf="criterion.id !== 1; else considerationTP">
                            {{
                                criterion.name === null ? 'Not defined' : criterion.tpValue
                            }}
                        </span>
                        <ng-template #considerationTP></ng-template>
                    </td> -->
                    <td mat-cell *matCellDef="let criterion"
                        [ngClass]="{
                            'bg-orange': criterion.name === null,
                            'bg-red': criterion.type == 'Default' && (criterion.values['tp'].kind == 'unknown' || criterion.values['tp'].kind == 'not applicable'),
                            'bg-green': criterion.type == 'Default'  && criterion.values['tp'].kind == 'simple',
                            'bg-gray': criterion.type == 'Consideration'
                        }">
                        <span *ngIf="criterion.type == 'Default'; else considerationTP">
                            {{ criterion.values['tp'].kind == 'simple' 
                                ? criterion.values['tp'].value 
                                : criterion.values['tp'].kind == 'unknown'
                                    ? 'Unknown'
                                    : 'Not Applicable' }}
                        </span>
                        <ng-template #considerationTP>
                        </ng-template>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="actions">
                    <td mat-cell *matCellDef="let criterion">
                        <button mat-icon-button color="primary" 
                            *ngIf="criterion.type == 'Default' || criterion.type == 'Custom'" 
                            (click)="onEditCriterion(viewModel.refNums, criterion)">
                            <mat-icon>create</mat-icon>
                        </button>
                        <button 
                            mat-icon-button 
                            (click)="onResetCriterion(criterion)"
                            *ngIf="criterion.isChanged">
                            <mat-icon [style.color]="'green'">refresh</mat-icon>
                        </button>
                        <button *ngIf="criterion.type === 'Default' || criterion.type == 'Custom'" 
                            mat-icon-button 
                            color="warn"
                            (click)="onRemoveCriterion(criterion)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="viewModel.headerColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: viewModel.displayedColumns; let i = index"
                    [ngClass]="{'colored-row': i%2}"></tr>
            </table>
        </div>
    </div>
    </ng-container>
</div>

<!-- <div class="col-md-12 kt-margin-bottom-20-mobile">
    <h5 class="my-3 text-mad text-uppercase">criterions</h5>
    <hr class="active">
</div>

<div class="col-md-12 d-flex justify-content-end">
    
</div> -->

